import { Typography, Grid } from '@mui/material';
import { useTranslation } from 'next-i18next';

import Style from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

const CourseNotFoundSuggestionMessage = () => {
  const { t } = useTranslation('common');
  return (
    <Style
      sx={{
        py: 2,
        px: { sm: 6, xs: 2 },
        flexFlow: 1,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs container>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography className="title" variant="h4" gutterBottom component="div">
                {t('all_course.course_not_found.title')}
              </Typography>
              <Typography className="description" variant="h4" component="div">
                <b>{t('all_course.course_not_found.desc')}</b>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item display="flex" alignItems="center">
          <FontAwesomeIcon icon="fa-light fa-radar" style={{ color: 'rgba(0, 83, 42, 0.12)', fontSize: '90px' }} />
        </Grid>
      </Grid>
    </Style>
  );
};

export default CourseNotFoundSuggestionMessage;
